export default __webpack_public_path__ + "static/surgical_boom_b.34dfece1d2146514969f3e495b8bd380.png";